import { render, staticRenderFns } from "./BrandPlatformIcon.vue?vue&type=template&id=7d984c0a&scoped=true"
import script from "./BrandPlatformIcon.vue?vue&type=script&lang=js"
export * from "./BrandPlatformIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d984c0a",
  null
  
)

export default component.exports